// extracted by mini-css-extract-plugin
export default {"Split":"reportView_Split__Ry2vb","GenerateReport":"reportView_GenerateReport__Sj3MM","Ids":"reportView_Ids__qdp9r"};